export default __webpack_public_path__ + "static/media/novo-login-mobile.6388ddc2.png";